// Parser de números en formato string en cualquier formato ('333.333.333,33' ó '333,333,333.33') a type number.

export const parseGroupedFloat = (stringValue: string): number => {
    stringValue = stringValue.trim();
    var result = stringValue.replace(/[^0-9\-]/g, '');
    if (/[,\.]\d{2}$/.test(stringValue)) {
        result = result.replace(/(\d{2})$/, '.$1');
    }
    return parseFloat(result);
}